import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  loading: true,
  loaded: false,
  data: {},
  error: {},
})

const { Types, Creators } = createActions({
  fetchTagsRequest: null,
  fetchTagsSuccess: ['data'],
  fetchTagsError: ['error'],

  setTags: ['data'],
})

export const fetchTagsRequest = state => state.set('loading', true)

export const fetchTagsSuccess = (state, { data }) =>
  state
    .set('data', data)
    .set('loading', false)
    .set('loaded', true)

export const fetchTagsError = (state, { error }) =>
  state
    .set('error', error)
    .set('loading', false)
    .set('loaded', false)

export const setTagsReducer = (state, { data }) => state.set('data', data)

export const tagReducer = createReducer(INITIAL_STATE, {
  [Types.FETCH_TAGS_REQUEST]: fetchTagsRequest,
  [Types.FETCH_TAGS_SUCCESS]: fetchTagsSuccess,
  [Types.FETCH_TAGS_ERROR]: fetchTagsError,

  [Types.SET_TAGS]: setTagsReducer,
})

export const TagTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/tagReducer.js